module.exports = __webpack_public_path__ + "static/img/banner11.6746a2c8.png";